module.exports = "/images/sala_multiuso.svg?d12439ae38d4ce1a53025bc53f5450a1";